import { render, staticRenderFns } from "./textEdit.vue?vue&type=template&id=fb7cb774&scoped=true"
import script from "./textEdit.vue?vue&type=script&lang=js"
export * from "./textEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7cb774",
  null
  
)

export default component.exports